import http from "../http-common";

class HomeDataService {
    searchPlayStore(data) {
        return http.get("admin/application/playstore/search", { params: data});
    }
    login(data) {
        return http.post("admin/users/login", data);
    }
    createProfile(data) {
        return http.post("admin/device-profile/create", data);
    }
    createQrCode(data) {
        return http.post("admin/qr-code/create", data);
    }
}

export default new HomeDataService();